import { render } from "./UserNameContainer.vue?vue&type=template&id=8a9b1820&scoped=true"
import script from "./UserNameContainer.vue?vue&type=script&lang=js"
export * from "./UserNameContainer.vue?vue&type=script&lang=js"

import "./UserNameContainer.vue?vue&type=style&index=0&id=8a9b1820&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9b1820"]])

export default __exports__